import { atomWithStorage, useIntl } from '@capsicum/common';
import { BaseCheckboxInput, Button, GenericDrawer, useGoatImage } from '@capsicum/common-web';
import { useSetAtom } from 'jotai';
import styled from 'styled-components';

export type AuctionBidConfirmDrawerProps = {
	onButtonPress: () => void;
	testID: string;
};

export const isBidWarningViewedAtom = atomWithStorage<boolean>('isBidWarningViewed', false);

export const AuctionBidConfirmDrawer = ({ onButtonPress, testID }: AuctionBidConfirmDrawerProps) => {
	const { $t } = useIntl();
	const setIsBidWarningViewedAtom = useSetAtom(isBidWarningViewedAtom);
	const goatAlertImage = useGoatImage('celebration');

	const description = (
		<S.DescriptionWrapper>
			<div>{$t('rewards.rpAuctions.bid.warningReminder')}</div>
			<div>
				<BaseCheckboxInput testID="auction-checkbox-place-bid-confirm" onChange={setIsBidWarningViewedAtom}>
					{$t('rewards.rpAuctions.bid.checkboxLabel')}
				</BaseCheckboxInput>
			</div>
			<S.ButtonWrapper>
				<Button
					color="brand"
					fullWidth
					testID="auction-button-place-bid-gotIt"
					text={$t('global.button.gotIt')}
					variant="default"
					onClick={() => {
						onButtonPress();
					}}
				/>
			</S.ButtonWrapper>
		</S.DescriptionWrapper>
	);

	const AuctionBidConfirmDrawerData = {
		description: description,
		image: goatAlertImage,
		testID: testID,
		title: $t('rewards.rpAuctions.bid.drawerTitle')
	};

	return <GenericDrawer {...AuctionBidConfirmDrawerData} />;
};

namespace S {
	export const DescriptionWrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.medium};
		align-items: center;
		margin-top: ${({ theme }) => theme.spacings.xsmall};
	`;
	export const ButtonWrapper = styled.div`
		display: flex;
		position: sticky;
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
		padding-top: ${({ theme }) => theme.spacings.large};
		bottom: 0;
		z-index: 9;
		align-self: center;
		width: 100%;
		align-items: center;
		justify-content: center;
		min-width: 100%;
		gap: ${({ theme }) => `${theme.spacings.xsmall}`};
		display: flex;
		flex-direction: column;
	`;
}
